import { DateTime } from "luxon";

const getNextOccuranceText = (eventDateTime: DateTime) => {
  const todayDateTime = DateTime.now().startOf("day");

  // find time to display
  let time = "";
  if (eventDateTime.minute > 0) {
    time = eventDateTime.toFormat(`h:mma`).toLocaleLowerCase();
  } else {
    time = eventDateTime.toFormat(`ha`).toLocaleLowerCase();
  }

  // find prefix
  let prefix = "";
  const startOfEventDate = eventDateTime.startOf("day");
  const startOfWeek = todayDateTime.startOf("week");
  const daysFromToday = startOfEventDate.diff(todayDateTime, ["days"]).days;
  const daysFromStartOfWeek = startOfEventDate.diff(startOfWeek, ["days"]).days + 1;

  const isMoreThanAWeekAgo = daysFromStartOfWeek < -7;
  const isLastWeek = daysFromStartOfWeek >= -7 && daysFromStartOfWeek < 0;
  const isToday = daysFromToday === 0;
  const isThisWeek = daysFromStartOfWeek >= 0 && daysFromStartOfWeek < 7;
  const isNextWeek = daysFromStartOfWeek >= 7 && daysFromStartOfWeek < 14;
  const isMoreThanNextWeekAway = daysFromStartOfWeek >= 14;

  if (isMoreThanAWeekAgo) prefix = `${eventDateTime.monthShort} ${eventDateTime.day}`;
  else if (isLastWeek) prefix = "Last";
  else if (isToday) prefix = "Today";
  else if (isThisWeek) prefix = "";
  else if (isNextWeek) prefix = "Next";
  else if (isMoreThanNextWeekAway) prefix = `${eventDateTime.monthShort} ${eventDateTime.day}`;

  return `${prefix}${prefix.length ? " " : ""}${eventDateTime.weekdayShort} ${time}`;
};

export default getNextOccuranceText;
